import { __assign } from 'tslib';
import React from 'react';
import Footer from '../Footer/index.js';
import MobileFooter from '../MobileFooter/index.js';

var WrapperFooter = function WrapperFooter(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Footer, __assign({}, props)), /*#__PURE__*/React.createElement(MobileFooter, __assign({}, props)));
};

export { WrapperFooter as default };
